import styled from 'styled-components'

const ProgressBar = styled.div<{readonly width?: number}>`
    height: 16px;
    width: ${props => `${props.width || 0}%`}};
    background: #3BB0D2;
    border-radius: 16px;
`

const FullProgressBar = styled(ProgressBar)`
    width: 100%;
    background: #F3F3F4;
    margin-top: 25px;
    margin-bottom: 18px;
`

export { ProgressBar, FullProgressBar }
